export enum PageAccessEntrySource {
    PageAccessRecipient = 1,
    NotebookResourcePermission = 2,
}

export type BasePageAccessEntry = {
    pageId: number;
    email: string;
    source: PageAccessEntrySource;
    userId?: number;
};
